import router from "@/router";
import store from "@/store";
import request from "@/api/index";
import { Dialog } from 'vant';
import qs from 'qs'
import { set } from "@/utils/localStorage";
import {replaceParamVal} from '@/utils/utils'
import {apiMe} from '@/api/copyright/common.js'

router.beforeEach((to, from, next) => {
    //权利卫士里面重定向到申请时间戳页面
    let ua=navigator.userAgent
    let isAndroid=(ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1) && ua.indexOf("ZGSDK") > -1;
    let isIOS = (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) && ua.indexOf("ZGSDK") > -1;
    if((isIOS || isAndroid) && to.path=="/copyright/index"){
        if(!to.query.redirect){
            next({
                path:'/time/ApplyTime',
                query:to.query
            });
            return
        }
    }

    store.commit('axiosCancel/clearAxiosPromiseCancelArr')
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.matched.length === 0) {
        //如果未匹配到路由
        from.name ? next({ name: from.name }) : next('/');
        //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    }


    const loginPath = [
        '/',
        '/qr',
        '/qr/',
        '/dTmatpkfPL.txt',
    ];
    zhuge.setSuperProperty({'端': 'H5'});
    if (loginPath.indexOf(to.path) !== -1) {
        //console.log(to.path)
        next();
    } else {
        let meUrl = '/me?hidden=true';
        let accessToken = to.query?.access_token || new URLSearchParams(window.location.search).get('access_token');
        if (accessToken) {
            meUrl += '&access_token=' + accessToken;
        }
        request({
            method: 'get',
            url: meUrl,
        }).then((res) => {
            store.commit('userInfo/setMe', res);
            zhuge.identify(res.id)
            if(to.query?.partnerType){
                set('partnerType',to.query.partnerType)
            }
            //参数带token替换token
            if(to.path=='/mine/Account'){
                if(to.query && to.query.url){
                    let url=decodeURIComponent(to.query.url);
                    console.log(url)
                    if (url.indexOf("?") !== -1 && url.indexOf("access_token")===1) {
                        let params = qs.parse(url);
                        console.log(params)
                        if(params.access_token !== res.accessToken){
                            let newUrl=replaceParamVal(url,'access_token',res.accessToken)
                            window.location.href='/mine/Account?url'+newUrl
                            return
                        }
                    }
                }
            }
            request({
                method: 'get',
                url: '/user',
            }).then(async(res2) => {
                //console.log(res)
                if (res2.forbidden) {
                    Dialog.alert({
                        title: '提示',
                        message: '您无权使用该服务，请与主账号管理员联系授权',
                        confirmButtonColor: '#008AFF'
                    }).then(() => {
                        window.location.href = process.env.VUE_APP_ACCOUNTUI
                    });
                    return false
                }
                store.commit('userInfo/setUserInfo', res2);
                if (to.path == '/time/ApplyResult') {
                    let serialNos = sessionStorage.getItem("serialNos");
                    if (!serialNos) {
                        next({
                            path: '/time/ApplyTime',
                        });
                    }
                }
                // 如果不是已认证作品列表页面和详情页面，则删除TsaMyConsultPage的缓存
                if (to.name !== 'CertifiedWork' && to.name !== 'CopyrightAuthDetail') {
                    store.commit('app/deleteKeepAliveArray', 'TsaCertifiedWorkPage')
                }
                next();
            })
        }).catch((err) => {
            let redirectUrl;
            if (to.path == '/time/ApplyTime' || to.path == '/copyright/index') {
                if(to.query){
                    redirectUrl = window.location.protocol + '//' + window.location.host + to.path+'?'+qs.stringify(to.query)
                }else{
                    redirectUrl = window.location.protocol + '//' + window.location.host + to.path
                }
            }else {
                redirectUrl = window.location.href
            }
            let params ={
                ...{ 
                    redirectUrl: encodeURIComponent(redirectUrl),
                    clientId:952310   
                },
                ...to.query,
            } 
            // console.log(params)
            // console.log(qs.stringify(params))
            window.location.href = process.env.VUE_APP_USERCENTERUI+'?'+ qs.stringify(params)
            // if (process.env.NODE_ENV === 'development') {
            //     window.location.href = '/api/login?' + qs.stringify(params)
            // } else {
            //     window.location.href = '/opus/api/login?' + qs.stringify(params)
            // }
        })
    }


})